var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', [_c('i', {
    staticClass: "iconfont icontijiaochenggong"
  }), _c('h3', [_c('p', [_vm._v("订单提交成功！请尽快完成支付哦～")]), _c('p', [_vm._v(" 请在 "), _c('CountDown', {
    attrs: {
      "time": _vm.surplus
    }
  }), _vm._v("内完成支付，超时将取消订单 ")], 1)])]), _c('span', [_vm._v(" 支付金额： "), _c('b', [_vm._v("¥" + _vm._s(_vm.totalPrice))])])]), _c('div', {
    staticClass: "wxcode"
  }, [_vm._m(0), _c('div', {
    staticClass: "code"
  }, [_c('div', {
    ref: "qrCodeUrl",
    staticClass: "qrcode"
  })]), _vm._m(1)]), _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("选择其他支付方式")])]), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('p', [_c('i', {
    staticClass: "iconfont iconweixinzhifu"
  }), _vm._v("微信支付 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "scancode"
  }, [_c('i', {
    staticClass: "iconfont iconshouhoubeifen"
  }), _c('span', [_c('b', [_vm._v("请使用微信“扫一扫”")]), _c('b', [_vm._v("扫描二维码支付")])])]);
}];
export { render, staticRenderFns };